import { Component, Inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { ToastrService } from 'ngx-toastr';
import { SharedService } from '../../services/shared.service';
import { ProfileData } from '../my-profile.component';

@Component({
    selector: 'app-edit-profile-dialog',
    standalone: true,
    imports: [
        CommonModule,
        ReactiveFormsModule,
        MatDialogModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        MatIconModule,
    ],
    templateUrl: './edit-profile-dialog.component.html',
    styleUrl: './edit-profile-dialog.component.scss',
})
export class EditProfileDialogComponent implements OnInit {
    editForm: FormGroup;
    saving = false;

    constructor(
        private fb: FormBuilder,
        private dialogRef: MatDialogRef<EditProfileDialogComponent>,
        private sharedService: SharedService,
        private toastr: ToastrService,
        @Inject(MAT_DIALOG_DATA) public data: { profile: ProfileData }
    ) {}

    ngOnInit(): void {
        this.editForm = this.fb.group({
            first_name: [this.data?.profile?.first_name ?? '', Validators.required],
            last_name:  [this.data?.profile?.last_name  ?? '', Validators.required],
            email:      [this.data?.profile?.email      ?? '', [Validators.required, Validators.email]],
        });
    }

    save(): void {
        if (this.editForm.invalid) {
            this.editForm.markAllAsTouched();
            return;
        }

        this.saving = true;

        this.sharedService.putRequest('/user/profile', this.editForm.value).subscribe(
            (res: any) => {
                this.saving = false;

                const userStr = localStorage.getItem('user');
                const user = userStr ? JSON.parse(userStr) : {};
                user.user_info = res.content;
                localStorage.setItem('user', JSON.stringify(user));

                this.dialogRef.close(this.editForm.value);
                // window.location.reload();
            },
            (err) => {
                this.saving = false;
                this.toastr.error('Error: ' + (err?.error?.message?.message ?? 'Something went wrong'));
            }
        );
    }
}